import { getMe, login, logout } from "./auth";

export * from "./auth";
export * from "./query-keys";
export * from "./react-query";
export * from "./transformers";

export const authApi = {
  me: () => getMe().then((data) => ({ data })),
  login: (body) => login(body).then((data) => ({ data })),
  logout: () => logout().then((data) => ({ data })),
};
